import { render, staticRenderFns } from "./NoticeCountsWidget.vue?vue&type=template&id=7257f3b0&"
import script from "./NoticeCountsWidget.vue?vue&type=script&lang=js&"
export * from "./NoticeCountsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports